import { Component, EventEmitter, OnDestroy, OnInit, Output, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormControl } from '@angular/forms'
import { RouterFacadeService } from '@services/router-facade.service';
import { UserModel } from '@models/user.model';

@Component({
  selector: 'data-deletion-form',
  templateUrl: './data-deletion-form.component.html',
  styleUrls: ['./data-deletion-form.component.sass'],

  
})


export class DataDeletionFormComponent implements OnInit, OnDestroy {
  @Input() user: UserModel
  @Output() submitRequest = new EventEmitter<any>();

  dataDeletionForm: FormGroup;
  constructor(
    private fb: FormBuilder,
    private routerFacadeService: RouterFacadeService
  ){}

  ngOnInit() {
    this.dataDeletionForm = this.fb.group({
      userId: [this.user.id,Validators.required],
      userEmail: [this.user.email, Validators.required]
    });  
  }

  navigateToBusinessDashboard() {
    this.routerFacadeService.navigateTo$("/")
  }

  ngOnDestroy(): void {
  }
}
